import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Logo from '../../assets/images/logo-white.svg';
import { toast } from 'sonner';
import { userUpdatePassword } from '../../api/loginApi';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { onLoggedin } from '../../actions';

const UpdatePassword = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { email } = location.state || {};

  // Redirect to login if email is not present
  useEffect(() => {
    if (!email) {
      navigate('/login');
    }
  }, [email, navigate]);

  // State variables for the password fields
  const [originalPassword, setOriginalPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmNewPassword, setConfirmNewPassword] = useState('');

  // Handle password field changes
  const handleOriginalPasswordChange = (e) =>
    setOriginalPassword(e.target.value);
  const handleNewPasswordChange = (e) => setNewPassword(e.target.value);
  const handleConfirmNewPasswordChange = (e) =>
    setConfirmNewPassword(e.target.value);

  // Handle password reset
  const handleSetPassword = async () => {
    // Validate the form inputs
    if (!email) {
      toast.error('Email is required');
      navigate('/login');
    }
    if (!originalPassword) {
      toast.error('Original password is required');
      return;
    }
    if (!newPassword || newPassword.length < 6) {
      toast.error('New password must be at least 6 characters');
      return;
    }
    if (newPassword !== confirmNewPassword) {
      toast.error('New passwords do not match');
      return;
    }

    // Call the API to update the password
    try {
      toast.promise(userUpdatePassword(email, originalPassword, newPassword), {
        loading: 'updating password in...',
        success: (data) => {
          props.onLoggedin(true);
          toast.success('Password updated successfully');
          navigate('/');
          return 'Logged in successfully!';
        },
        error: (err) => {
          toast.error('Failed to update password');
          return 'Invalid password';
        },
        duration: 800
      });

    } catch (error) {
      toast.error('Failed to update password');
    }
  };

  return (
    <div className="theme-cyan">
      <div>
        <div className="vertical-align-wrap">
          <div className="vertical-align-middle auth-main">
            <div className="auth-box">
              <div className="top">
                <img
                  src={Logo}
                  alt="Logo"
                  style={{ height: '40px', margin: '10px' }}
                />
              </div>
              <div className="card">
                <div className="header">
                  <p className="lead">Update Password for {email}</p>
                </div>
                <div className="body">
                  <div className="form-auth-small">
                    <div className="form-group">
                      <label className="control-label">Original Password</label>
                      <input
                        className="form-control"
                        type="password"
                        placeholder="Enter original password"
                        value={originalPassword}
                        onChange={handleOriginalPasswordChange}
                      />
                    </div>

                    <div className="form-group">
                      <label className="control-label">New Password</label>
                      <input
                        className="form-control"
                        type="password"
                        placeholder="Enter new password"
                        value={newPassword}
                        onChange={handleNewPasswordChange}
                      />
                    </div>

                    <div className="form-group">
                      <label className="control-label">
                        Confirm New Password
                      </label>
                      <input
                        className="form-control"
                        type="password"
                        placeholder="Confirm new password"
                        value={confirmNewPassword}
                        onChange={handleConfirmNewPasswordChange}
                      />
                    </div>

                    <button
                      className="btn btn-primary btn-lg btn-block"
                      onClick={handleSetPassword}
                    >
                      UPDATE PASSWORD
                    </button>

                    <div className="bottom">
                      <span className="helper-text">
                        Know your password? <a href="/login">Login</a>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

UpdatePassword.propTypes = {
  isLoggedIn: PropTypes.bool,
};

const mapStateToProps = ({ loginReducer }) => ({
  isLoggedIn: loginReducer.isLoggedIn,
});

export default connect(mapStateToProps, { onLoggedin })(UpdatePassword);
